import {Alert, Snackbar} from '@mui/material'

interface NotificationSnackbarProps {
    open: boolean;
    message: string | null
    onClose: () => void
    severity: 'error' | 'warning' | 'info' | 'success'
    autoHideDuration?: number
    anchorOrigin?: {vertical: 'top' | 'bottom'; horizontal: 'left' | 'center' | 'right'}
}

export const NotificationSnackbar = ({
                                  open,
                                  message,
                                  onClose,
                                  severity,
                                  autoHideDuration = 6000,
                                  anchorOrigin = {vertical: 'top', horizontal: 'right'}
                              }: NotificationSnackbarProps) => {
    return (
        <Snackbar
            open={open && message !== null}
            onClose={onClose}
            autoHideDuration={autoHideDuration}
            anchorOrigin={anchorOrigin}
        >
            <Alert
                onClose={onClose}
                severity={severity}
                variant="filled"
                sx={{width: '100%'}}
            >
                {message}
            </Alert>
        </Snackbar>
    )
}
